<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="60%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="客服" prop="peopleId">
          <el-select v-model="form.peopleId" placeholder="请选择客服">
            <el-option
              v-for="item in roles"
              :key="item.peopleId"
              :label="`${item.basic.name}（${item.basic.customId}）`"
              :value="item.peopleId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createStaff } from '@/api/chat'
import { getAllStaffs } from '@/api/branch'

export default {
  name: 'PeopleEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      roles: [],
      form: {
        peopleId: '',
      },
      rules: {
        peopleId: [{ required: true, trigger: 'blur', message: '请选择客服' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit() {
      this.title = '新增客服'
      this.roles = await getAllStaffs()
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.$baseConfirm(
            `你确定要新增客服吗`,
            null,
            async () => {
              await createStaff(this.form)
              this.$baseMessage(
                `新增客服成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
